// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__5rH5A","loaderOuter":"PageOverlayLoader_loaderOuter__ZrWgq"};